import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './TagInput';
import { searchTags } from './redux/actions';
import { getSearchRequestStatus, getSearchResults } from './redux/selectors';

export type StateProps = Pick<Props, 'tagSuggestions'>;
export type DispatchProps = Pick<Props, 'searchRequest'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  tagSuggestions: getSearchResults(state),
  searchRequestStatus: getSearchRequestStatus(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  searchRequest: query => searchTags(query),
};

export default connect(mapStateToProps, mapDispatchToProps, undefined, {
  forwardRef: true,
});
